export default "__VITE_ASSET__CRYaDCj7__"